module.exports = __webpack_public_path__ + "img/Primordial-Process-9.b6dfd6a7.png";